import "./App.css";
import FullscreenSlider from "./modules/fullscreen_slider/";
import EMC0 from "./img/0_to_otumto.JPG";
import EMC1 from "./img/1_tadamo_o.png";
function App() {
  return (
    <div class="scroller">
      <section class="title">
        <div>
          <div class="title">
            <div>
              <p class="p1 jersey-15-regular">KODAWARIS</p>
              <p class="p2 jersey-15-regular">ver 0.1.0</p>
            </div>
          </div>
        </div>
        <div class="arrows">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </section>
      <section class="patch-notes">
        <div class="item">
          <div class="polaroid">
            <img src={EMC0} width="200" />
            <div class="caption">to_otumto</div>
            <div class="date">2025.03.15</div>
          </div>
        </div>
        <div class="item">
          <div class="polaroid">
            <img src={EMC1} width="200" />
            <div class="caption">tadamo_o</div>
            <div class="date">2025.03.31</div>
          </div>
        </div>

        <div class="title">
          <p class="jersey-15-regular">every moment counts</p>
        </div>
      </section>
      {/* <section class="patch-notes">
        <div class="patch-notes">
          <div>
            <p class="p1 jersey-15-regular">PATCH NOTES</p>
            <p class="p2 jersey-15-regular">ver 0.0.1</p>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default App;
